"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButtonContainer = exports.StyledDetailsBlock = exports.StyledConfirmDetailsContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledConfirmDetailsContainer = _styledComponents.default.div.withConfig({
  displayName: "ConfirmDetailsstyles__StyledConfirmDetailsContainer",
  componentId: "sc-1f1g52l-0"
})(["align-items:flex-start;border-radius:2px;border:", " solid ", ";display:flex;flex-direction:row;justify-content:space-between;margin:", ";padding:.75rem;width:", ";"], function (props) {
  return props.theme.thinLine;
}, function (props) {
  return props.theme.c_foreground_gridLines;
}, function (props) {
  return props._inStyleGuide ? props.theme.fullsizeComponentOffset : '0';
}, function (props) {
  return props._inStyleGuide ? props.theme.componentSizeLarge : '100%';
});

exports.StyledConfirmDetailsContainer = StyledConfirmDetailsContainer;

var StyledDetailsBlock = _styledComponents.default.div.withConfig({
  displayName: "ConfirmDetailsstyles__StyledDetailsBlock",
  componentId: "sc-1f1g52l-1"
})(["flex:1 1 auto;display:flex;flex-direction:column;> *{padding:0;margin:0;padding-top:.5rem;color:", ";&:first-child{font-weight:", ";}&:last-child{padding-bottom:.5rem;}}"], function (props) {
  return props.theme.c_foreground_default;
}, function (props) {
  return props.theme.primaryMedium;
});

exports.StyledDetailsBlock = StyledDetailsBlock;

var StyledButtonContainer = _styledComponents.default.div.withConfig({
  displayName: "ConfirmDetailsstyles__StyledButtonContainer",
  componentId: "sc-1f1g52l-2"
})(["flex:0 0 auto;padding-top:.5rem;"]);

exports.StyledButtonContainer = StyledButtonContainer;